<app-ds-badge class="badge" type="{{getColor()}}">
  {{showRemainingTimeLabel() | translate: { months: remainingTime.months, days: remainingTime.days, hour: remainingTime.hours } }}
</app-ds-badge>
